const u = (id, w = 1600) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=2000",
  bathwareDark: "https://images.unsplash.com/photo-1756079664354-34944e001f6d?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1800",
  blueprint: "https://images.unsplash.com/photo-1542621334-a254cf47733d?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1600",
  livingRoom: "https://images.pexels.com/photos/8082243/pexels-photo-8082243.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  paintInterior: u("photo-1618221195710-dd6b41faaea6"),
  about: u("photo-1600585154340-be6161a56a0c"),
};

export const CATEGORIES = [
  {
    slug: "decorative-paints",
    name: "Decorative Paints",
    short: "Paints and finishing products from trusted brands for interiors and exteriors.",
    description:
      "Interior and exterior decorative paints, primers, emulsions and finishes from brands Indian homes have trusted for decades. Tell us the surface and the look you want — we help you pick the right product.",
    brands: ["Nerolac", "Dulux", "Indigo", "JK Paints"],
    image: "https://images.unsplash.com/photo-1525909002-1b05e0c869d8?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1400",
    applications: ["Interior walls & ceilings", "Exterior surfaces", "Primers & topcoats", "Special finishes"],
  },
  {
    slug: "pipes-fittings",
    name: "Pipes & Fittings",
    short: "Complete plumbing pipe and fitting solutions for every layout.",
    description:
      "A complete range of plumbing pipes and fittings for new construction and renovation — from water supply lines to drainage, with the fittings to match.",
    brands: ["Supreme Pipes", "Vectus"],
    image: u("photo-1585704032915-c3400ca199e7", 1400),
    applications: ["Hot & cold water lines", "Drainage & waste systems", "Fittings & joints", "New builds & repairs"],
  },
  {
    slug: "water-storage",
    name: "Water Storage",
    short: "Dependable water tanks and storage solutions for homes and projects.",
    description:
      "Water storage solutions for homes, buildings and project sites — overhead and storage tanks built for daily dependability.",
    brands: ["Gangotri Tanks"],
    image: u("photo-1504328345606-18bbc8c9d7d1", 1400),
    applications: ["Overhead water storage", "Household storage", "Building & project supply"],
  },
  {
    slug: "luxury-bathware",
    name: "Luxury Bathware",
    short: "Bathtubs, jetted baths, sanitaryware and premium bathroom fittings.",
    description:
      "Premium bathroom and bathing solutions — bathtubs, jacuzzis and jetted baths, sanitaryware and fittings that turn a bathroom into a space you look forward to.",
    brands: ["Somany Bathware", "Cubix", "Bathberry"],
    image: u("photo-1620626011761-996317b8d101", 1400),
    applications: ["Bathtubs", "Jacuzzis & jetted baths", "Sanitaryware", "Bathroom fittings"],
  },
  {
    slug: "kitchen-sinks",
    name: "Kitchen Sinks",
    short: "Premium kitchen sink solutions built for everyday use.",
    description:
      "Premium kitchen sinks that balance looks with everyday durability — options for compact kitchens and large family kitchens alike.",
    brands: ["Jim Sinks"],
    image: u("photo-1556911220-bff31c812dba", 1400),
    applications: ["Single & double bowl sinks", "Premium finishes", "Kitchen renovations", "New kitchens"],
  },
  {
    slug: "construction-chemicals",
    name: "Construction Chemicals",
    short: "Products for construction, repair, protection and finishing.",
    description:
      "Construction chemicals and building solutions for waterproofing, repair, protection and finishing — the products professionals reach for when the job has to last.",
    brands: ["Pidilite Dr. Fixit"],
    image: u("photo-1504307651254-35680f356dfd", 1400),
    applications: ["Waterproofing", "Crack & leak repair", "Surface protection", "New construction"],
  },
  {
    slug: "white-cement-putty-adhesives",
    name: "White Cement, Putty & Tile Adhesives",
    short: "Building finishing and installation products from JK.",
    description:
      "Finishing and installation essentials — white cement, wall putty and tile adhesives that give walls and tiles a clean, lasting finish.",
    brands: ["JK White Cement", "JK Wall Putty", "JK Tile Adhesive / JKTYLO"],
    image: u("photo-1562259949-e8e7689d7828", 1400),
    applications: ["Wall putty & finishing", "Tile installation", "White cement applications"],
  },
  {
    slug: "plumbing-essentials",
    name: "Plumbing Essentials",
    short: "Additional plumbing and installation essentials under one roof.",
    description:
      "The everyday plumbing and installation essentials that complete the job — so your plumber leaves with everything needed in one visit.",
    brands: [],
    image: u("photo-1607472586893-edb57bdc0e39", 1400),
    applications: ["Installation essentials", "Connectors & accessories", "Repairs & maintenance"],
  },
];

export const BRANDS = [
  { name: "Nerolac", category: "Decorative Paints" },
  { name: "Dulux", category: "Decorative Paints" },
  { name: "Indigo", category: "Decorative Paints" },
  { name: "JK Paints", category: "Decorative Paints" },
  { name: "Supreme Pipes", category: "Pipes & Fittings" },
  { name: "Vectus", category: "Pipes & Fittings" },
  { name: "Gangotri Tanks", category: "Water Storage" },
  { name: "Somany Bathware", category: "Luxury Bathware" },
  { name: "Cubix", category: "Luxury Bathware" },
  { name: "Bathberry", category: "Luxury Bathware" },
  { name: "Jim Sinks", category: "Kitchen Sinks" },
  { name: "Pidilite Dr. Fixit", category: "Construction Chemicals" },
  { name: "JK White Cement", category: "Finishing & Adhesives" },
  { name: "JK Wall Putty", category: "Finishing & Adhesives" },
  { name: "JK Tile Adhesive / JKTYLO", category: "Finishing & Adhesives" },
];

export const VALUE_PROPS = [
  { title: "Trusted Brands", text: "Established brands across every category we stock." },
  { title: "Complete Home Solutions", text: "From structure to finish — sourced under one roof." },
  { title: "Multi-Category Expertise", text: "Real product knowledge across paints, plumbing and bathware." },
  { title: "Retail, Wholesale & Distribution", text: "Built for homeowners and for professional requirements alike." },
  { title: "Customer-Focused Service", text: "Guidance first, so you buy what your project actually needs." },
];

export const WHY_CLB = [
  { title: "Multiple Categories", text: "Source products across essential home and construction categories from one place." },
  { title: "Trusted Brands", text: "We work with established brands across paints, plumbing, bathware and construction solutions." },
  { title: "Retail & Wholesale", text: "Serving individual customers as well as professional and project requirements." },
  { title: "Complete Home Solutions", text: "From the walls and plumbing to bathrooms and finishing materials, CLB covers multiple stages of a project." },
  { title: "Product Guidance", text: "We help you identify suitable products for your specific requirement — not just what's on the shelf." },
  { title: "Long-Term Relationships", text: "Our business is built on trust, service and relationships that outlast any single transaction." },
];

export const AUDIENCES = [
  { icon: "Home", title: "Homeowners", text: "Building new or renovating — get honest guidance and the right products for your home." },
  { icon: "Wrench", title: "Contractors", text: "Reliable supply across categories so your site never waits on material." },
  { icon: "Building2", title: "Builders & Developers", text: "Wholesale and project-scale requirements handled with professional consistency." },
  { icon: "DraftingCompass", title: "Architects & Designers", text: "Premium bathware, finishes and fittings that match the standard of your design." },
  { icon: "Paintbrush", title: "Plumbers & Painters", text: "The brands and materials you already trust, available when you need them." },
  { icon: "Factory", title: "Commercial & Project Buyers", text: "Institutional and bulk requirements served through our distribution capability." },
];

export const BUSINESS_MODEL = [
  { num: "01", title: "Distribution", text: "Supporting supply requirements across our product categories with dependable availability." },
  { num: "02", title: "Wholesale", text: "Serving contractors, professionals, businesses and larger project requirements." },
  { num: "03", title: "Retail", text: "Helping homeowners and individual customers choose the right products for their projects." },
];

export const FEATURED = [
  { name: "Luxury Bathware Collection", brand: "Somany Bathware", category: "luxury-bathware", categoryLabel: "Luxury Bathware", text: "Bathtubs, jetted baths, sanitaryware and fittings for bathrooms that feel like a retreat.", image: u("photo-1620626011761-996317b8d101", 1400) },
  { name: "Decorative Paint Range", brand: "Nerolac", category: "decorative-paints", categoryLabel: "Decorative Paints", text: "Interior and exterior paints and finishes for walls that carry the home.", image: u("photo-1618221195710-dd6b41faaea6", 1200) },
  { name: "Plumbing Pipe Systems", brand: "Supreme Pipes", category: "pipes-fittings", categoryLabel: "Pipes & Fittings", text: "Pipes and fittings for supply and drainage — the backbone of every build.", image: u("photo-1585704032915-c3400ca199e7", 1200) },
  { name: "Waterproofing & Repair Solutions", brand: "Pidilite Dr. Fixit", category: "construction-chemicals", categoryLabel: "Construction Chemicals", text: "Protection and repair products professionals trust when the job has to last.", image: u("photo-1504307651254-35680f356dfd", 1200) },
];

export const PLUMBING_CONSTRUCTION_ITEMS = [
  "Pipes & Fittings",
  "Water Storage",
  "Construction Chemicals",
  "White Cement",
  "Wall Putty",
  "Tile Adhesives",
  "Plumbing Essentials",
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Categories", to: "/categories" },
  { label: "Brands", to: "/brands" },
  { label: "Solutions", to: "/solutions" },
  { label: "Contact", to: "/contact" },
];
